var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ResetKey50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 42.7083L27.0833 46.875H22.9167L18.75 42.7083V21.875H31.25V30.2083L29.1667 32.2917L31.25 34.375V36.4583L29.1667 38.5417L31.25 40.625V42.7083Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5833 8.125C39.0625 6.25 37.5 4.89583 35.7292 4.375C33.2292 3.85417 29.375 3.125 25 3.125C20.625 3.125 16.7708 3.85417 14.2708 4.375C12.5 4.89583 10.9375 6.25 10.4167 8.125C9.89583 9.89583 9.375 12.3958 9.375 15.1042C9.375 17.8125 9.89583 20.3125 10.4167 22.0833C10.9375 23.9583 12.3958 25.3125 14.2708 25.7292C16.7708 26.3542 20.625 27.0833 25 27.0833C29.375 27.0833 33.2292 26.3542 35.7292 25.8333C37.6042 25.4167 39.0625 23.9583 39.5833 22.1875C40.1042 20.4167 40.625 17.9167 40.625 15.2083C40.625 12.3958 40.1042 9.89583 39.5833 8.125ZM30.2083 13.5417H19.7917C18.6458 13.5417 17.7083 12.6042 17.7083 11.4583V9.375C17.7083 8.75 20.9375 8.33333 25 8.33333C29.0625 8.33333 32.2917 8.75 32.2917 9.375V11.4583C32.2917 12.6042 31.3542 13.5417 30.2083 13.5417Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 27.0833H26.0416V46.875H23.9583V27.0833Z",
    fill: "#D68600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 48.8333C43.9831 48.8333 48.8334 43.9831 48.8334 38C48.8334 32.0169 43.9831 27.1667 38 27.1667C32.0169 27.1667 27.1667 32.0169 27.1667 38C27.1667 43.9831 32.0169 48.8333 38 48.8333Z",
    fill: "#3DD9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 32.0417L39.9105 35.2727L44.5 36.9167V32.0417Z",
    fill: "#C2FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9509 35.1611L43.7265 33.9115C42.4482 32.1251 40.359 30.9583 38 30.9583C34.4862 30.9583 31.5742 33.5475 31.0504 36.9167H33.2507C33.7452 34.7489 35.6849 33.125 38 33.125C39.6277 33.125 41.0653 33.9315 41.9509 35.1611Z",
    fill: "#C2FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9509 35.1611L43.7265 33.9115C43.5147 33.6158 43.2732 33.3438 43.0191 33.0844L41.2175 34.3524C41.4905 34.5945 41.7375 34.8643 41.9509 35.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 43.9583L36.0895 40.7273L31.5 39.0833V43.9583Z",
    fill: "#C2FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0491 40.8389L32.2735 42.0885C33.5518 43.8749 35.641 45.0417 38 45.0417C41.5138 45.0417 44.4258 42.4525 44.9496 39.0833H42.7493C42.2548 41.2511 40.3151 42.875 38 42.875C36.3723 42.875 34.9347 42.0685 34.0491 40.8389Z",
    fill: "#C2FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0491 40.8389L32.2735 42.0885C32.4853 42.3842 32.7269 42.6562 32.9809 42.9156L34.7825 41.6476C34.5095 41.4055 34.2625 41.1357 34.0491 40.8389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ResetKey50);
export default __webpack_public_path__ + "static/media/icons8-reset-key-50.beb6d28dcc27c306a7fa6afe00b0f3e4.svg";
export { ForwardRef as ReactComponent };